// removed by extract-text-webpack-plugin
module.exports = {"potential-client-tags":"potential-client-tags","tagsClass":"tagsClass","tagInputClass":"tagInputClass","adjusted-width":"adjusted-width","tagInputFieldClass":"tagInputFieldClass","selectedClass":"selectedClass","tagClass":"tagClass","removeClass":"removeClass","suggestionsClass":"suggestionsClass","activeSuggestionClass":"activeSuggestionClass"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Form/Fields/Tags/Tags.scss
// module id = 0oPG
// module chunks = 0